import type { AdminWhatsappTemplateRow } from '../../../domain/superadmin/types';
import { WhatsappTemplateCard } from './WhatsappTemplateCard';

interface WhatsappTemplatesGridProps {
    items: AdminWhatsappTemplateRow[];
    onPreview: (template: AdminWhatsappTemplateRow) => void;
    onTest: (template: AdminWhatsappTemplateRow) => void;
    onDeliveryChange: (template: AdminWhatsappTemplateRow, active: boolean) => void;
    testDisabled?: boolean;
}

export function WhatsappTemplatesGrid({
    items,
    onPreview,
    onTest,
    onDeliveryChange,
    testDisabled = false,
}: WhatsappTemplatesGridProps) {
    if (items.length === 0) {
        return (
            <p className="py-12 text-center text-sm text-muted">
                Nenhum template de WhatsApp encontrado.
            </p>
        );
    }

    return (
        <section
            className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3"
            aria-label="Templates de WhatsApp"
        >
            {items.map((template) => (
                <WhatsappTemplateCard
                    key={template.key}
                    template={template}
                    onPreview={onPreview}
                    onTest={onTest}
                    onDeliveryChange={(active) => onDeliveryChange(template, active)}
                    testDisabled={testDisabled}
                />
            ))}
        </section>
    );
}
